import {
  GET_ALL_VALID_PLANS_BEGIN, GET_ALL_VALID_PLANS_SUCCESS, GET_ALL_VALID_PLANS_FAILURE,
  POST_CREATE_PLAN_BEGIN, POST_CREATE_PLAN_SUCCESS, POST_CREATE_PLAN_FAILURE,
  CLEAR_PLANS
} from './../constants/ActionTypes'

const initialState = {
  plans: null,
  plansError: null,
  loadingPlans: false,

  createdPlan: null,
  createPlanError: null,
  creatingPlan: false
}

const ReducerPlan = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ALL_VALID_PLANS_BEGIN: {
      return {
        ...state,
        loadingPlans: true,
        plansError: null,
        plans: null
      }
    }
    case GET_ALL_VALID_PLANS_SUCCESS: {
      return {
        ...state,
        loadingPlans: false,
        plansError: null,
        plans: payload.response
      }
    }
    case GET_ALL_VALID_PLANS_FAILURE: {
      return {
        ...state,
        loadingPlans: false,
        plansError: payload,
        plans: null
      }
    }

    case POST_CREATE_PLAN_BEGIN: {
      return {
        ...state,
        createdPlan: null,
        createPlanError: null,
        creatingPlan: true
      }
    }
    case POST_CREATE_PLAN_SUCCESS: {
      return {
        ...state,
        createdPlan: payload.response,
        createPlanError: null,
        creatingPlan: false
      }
    }
    case POST_CREATE_PLAN_FAILURE: {
      return {
        ...state,
        createdPlan: null,
        createPlanError: payload,
        creatingPlan: false
      }
    }

    case CLEAR_PLANS: {
      return initialState
    }

    default: return state
  }
}

export default ReducerPlan